import React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import { mediaQueryOnly, mediaQueryUp } from 'components/utils/breakpoint'
import LeBusinessTravellerLogo from './LeBusinessTravellerLogo'
import LeBusinessTravellerSmallLogo from './LeBusinessTravellerSmallLogo'
import type { ResponsiveLogoProps } from './ResponsiveLuxuryEscapesLogo'

const HideableLogo = styled.div`
  &.hidden-at-mobile {
    ${mediaQueryOnly.mobile} { display: none; }
  }
  &.hidden-at-tablet {
    ${mediaQueryOnly.tablet} { display: none; }
  }
  &.hidden-at-desktop {
    ${mediaQueryOnly.desktop} { display: none; }
    ${mediaQueryOnly.largeDesktop} { display: none; }
  }
  &.hidden-at-extra-desktop-lg-and-up {
    ${mediaQueryUp.extraLargeDesktop} { display: none; }
  }

  & + & {
    margin-left: 0;
  }
`

type Props = React.SVGAttributes<SVGSVGElement> & ResponsiveLogoProps

function ResponsiveLeBusinessTravellerLogo(props: Props) {
  const {
    mobileVariant = 'icon',
    tabletVariant = 'icon+text',
    desktopVariant = 'icon+text',
    extraLargeDesktopVariant = 'icon+text',
    className,
    ...rest
  } = props

  return <>
    <HideableLogo
      as={LeBusinessTravellerSmallLogo}
      width={35}
      height={35}
      {...rest}
      className={clsx(className, {
        'hidden-at-mobile': mobileVariant !== 'icon',
        'hidden-at-tablet': tabletVariant !== 'icon',
        'hidden-at-desktop': desktopVariant !== 'icon',
        'hidden-at-extra-desktop-lg-and-up': extraLargeDesktopVariant !== 'icon',
      })}
    />
    <HideableLogo
      as={LeBusinessTravellerLogo}
      {...rest}
      className={clsx(className, {
        'hidden-at-mobile': mobileVariant !== 'icon+text',
        'hidden-at-tablet': tabletVariant !== 'icon+text',
        'hidden-at-desktop': desktopVariant !== 'icon+text',
        'hidden-at-extra-desktop-lg-and-up': extraLargeDesktopVariant !== 'icon+text',
      })}
    />
  </>
}

export default ResponsiveLeBusinessTravellerLogo
